module.exports = __webpack_public_path__ + "static/media/kerning.3db90f60.svg";